import { Component, Input } from '@angular/core'
import { MatDialogActions } from '@angular/material/dialog'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'dialog-actions-container',
	templateUrl: './DialogActions.Component.html',
	imports: [MatDialogActions, NgStyle],
})
export class DialogActionsComponent {
	@Input() public styles: any
}
